import { render, staticRenderFns } from "./BillInfoTable.vue?vue&type=template&id=ce5bfef8&scoped=true"
import script from "./BillInfoTable.vue?vue&type=script&lang=js"
export * from "./BillInfoTable.vue?vue&type=script&lang=js"
import style0 from "./BillInfoTable.vue?vue&type=style&index=0&id=ce5bfef8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5bfef8",
  null
  
)

export default component.exports